import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
const faqs = [{
  question: 'Do you charge upfront fees?',
  answer: "No. We never charge upfront fees. Our fee is paid at the closing table from the proceeds of your deal. If the deal doesn't close, you don't pay."
}, {
  question: 'Do you pull my credit?',
  answer: 'No. Our transactional funding is 100% asset-based. We do not pull your credit or require personal guarantees. We fund based entirely on the merits of the deal.'
}, {
  question: 'How fast can you fund?',
  answer: 'We can fund in as little as 24–48 hours if all paperwork is in order and title is clear. We recommend submitting your deal as soon as you have an executed contract to ensure a smooth closing process.'
}, {
  question: 'What types of deals do you fund?',
  answer: 'We specialize in EMD funding, double closings, and stack-method transactions for wholesalers. Single family, multi-family, commercial, and land — if there is a clear exit and a clean title, we can fund it.'
}, {
  question: 'Do I need to bring my own buyer?',
  answer: 'For double closings, yes — you will need a qualified end buyer ready to close. For EMD funding, we just need to see the executed purchase contract. Our team can walk you through what is required for each scenario.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="bg-[#f2efeb] border-t border-[#d9d3cb]" data-id="element-106">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="mb-12 lg:mb-16" data-id="element-108">
          <p className="text-xs sm:text-sm tracking-widest uppercase text-[#c9a875] font-medium mb-4" data-id="element-109">
            Frequently Asked
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif-display text-[#2b2826] leading-tight" data-id="element-110">
            Questions, answered.
          </h2>
        </div>

        <div className="border-t border-[#2b2826]/15" data-id="element-111">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="border-b border-[#2b2826]/15" data-id="element-112">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-start justify-between gap-6 py-6 sm:py-8 text-left group !rounded-none !shadow-none hover:!shadow-none hover:!translate-y-0 !min-h-0 !font-normal" aria-expanded={isOpen} data-id="element-113">
                  <span className={`font-serif-display text-xl sm:text-2xl md:text-3xl leading-snug transition-colors ${isOpen ? 'text-[#2b2826]' : 'text-[#2b2826]/85 group-hover:text-[#2b2826]'}`} data-id="element-114">
                    {faq.question}
                  </span>
                  <span className={`flex-shrink-0 mt-2 sm:mt-3 transition-transform duration-300 ${isOpen ? 'rotate-45 text-[#c9a875]' : 'text-[#2b2826]/60'}`} data-id="element-115">
                    <PlusIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-116" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-117">
                  {isOpen && <motion.div key="content" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                height: {
                  duration: 0.35,
                  ease: [0.16, 1, 0.3, 1]
                },
                opacity: {
                  duration: 0.25
                }
              }} className="overflow-hidden" data-id="element-118">
                      <p className="pb-6 sm:pb-8 pr-12 text-base sm:text-lg text-[#2b2826]/70 leading-relaxed font-light" data-id="element-119">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
};